// import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';

import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

// import { dataConfig } from 'data/dataConfig';

import { COMBINED } from 'data/dataSourceConstants';

import { useMediaPredicate } from 'react-media-hook';
import { MOBILE_SIZE } from 'utils/mediaQueryUtils';

import OutboundLink from 'components/OutboundLink';

function RecordDetailsLink({ isBis, row, dataSet, dataSource }) {
	const dispatch = useDispatch();
	const isMobile = useMediaPredicate(MOBILE_SIZE);
	// let config = dataConfig[dataSet];

	let modalButton = (
		<button
			className="btn-hyperlink"
			onClick={() =>
				dispatch(
					openModal(MODAL_TYPES.RECORD_DETAILS, {
						dataSet,
						id: row.id,
						dataSource,
						row,
					})
				)
			}
		>
			<i className="bi bi-info-circle" />
		</button>
	);

	// let pageLink = (
	// 	<Link to={`/${config.urlPath}/${row.id}`}>
	// 		<i className="bi bi-info-circle" />
	// 	</Link>
	// );

	const bisUrl = row.url || row.uri || row.device_number_uri;
	let outboundLink = (
		<OutboundLink url={bisUrl}>
			<i className="bi bi-info-circle" />
		</OutboundLink>
	);
	if (dataSet === 'bisIlluminatedSigns') {
		return modalButton;
	}

	// BIS boilers use the details modal (Num already links out to BIS via uri)
	if (dataSet === 'bisBoilers' && row?.id) {
		return modalButton;
	} else if (isBis && bisUrl) {
		return outboundLink;
	} else if (dataSource === COMBINED) {
		return modalButton;
	} else if (!isBis && dataSet && row?.id) {
		if (isMobile) {
			// return pageLink;
			return modalButton;
		}
		return modalButton;
	}

	//this can happen if there's no row.url/uri and data source is BIS
	return null;
}

export default RecordDetailsLink;
